module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td style="min-width: 87px;" class="center">'+
((__t=( formatDate(start) ))==null?'':__t)+
'</td>\r\n<td style="min-width: 87px;" class="center">'+
((__t=( formatDate(finish) ))==null?'':__t)+
'</td>\r\n<td style="min-width: 200px;" class="center">'+
((__t=( m0040_pat_lname ))==null?'':__t)+
''+
((__t=( m0040_pat_fname ))==null?'':__t)+
'</td>\r\n<td style="min-width: 140px;" class="center">'+
((__t=( ins ))==null?'':__t)+
'</td>\r\n<!--\r\n<td style="min-width: 20px;">'+
((__t=( lic ))==null?'':__t)+
'</td>\r\n-->\r\n<td style="min-width: 25px;" class="center">'+
((__t=( service ))==null?'':__t)+
'</td>\r\n<td style="min-width: 25px;" class="center">'+
((__t=( vis_type ))==null?'':__t)+
'</td>\r\n<td style="min-width: 25px;" class="center">'+
((__t=( empl_type ))==null?'':__t)+
'</td>\r\n<td style="min-width: 10px;" class="center">\r\n<input type="checkbox" disabled ';
 if (marked) { 
__p+=' checked ';
 } 
__p+=' >\r\n</td>\r\n<td style="min-width: 150px;" class="center">'+
((__t=( authorizationnumber ))==null?'':__t)+
'</td>\r\n\r\n										\r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/organizations/organization-patients-jf-visits-row.html
// module id = 296
// module chunks = 0